<nz-range-picker
  [name]="config.name"
  [nzPlaceHolder]="config.placeholder"
  [nzAllowClear]="config.allowClear"
  [ngModel]="config.value | dateRangePipe"
  (ngModelChange)="onChange($event)"
  [nzFormat]="dateFormat"
  [required]="config.required"
  style="width: 100%"
></nz-range-picker>
